import axios from "axios";

export const autoComplete = search => {
  return axios
    .get(`  https://suggestions.pappers.fr/v2?q=${search}`, {})
    .then(({ data }) => {
      if (!data.resultats_nom_entreprise) return [];
      return data.resultats_nom_entreprise;
    })
    .catch(function(error) {
      console.log(error);
      return [];
    })
    .finally(function() {});
};

const searchDenominations = denomination => {
  return axios
    .get(`https://api.pappers.fr/v2/recherche`, {
      params: {
        api_token: "7321576a0c25647afbb34c5485500bc4e0714fd97e78afab",
        nom_entreprise: denomination
      }
    })
    .then(({ data }) => {
      console.log(data.resultats);
      if (!data.resultats) return [];
      return data.resultats_nom_entreprise;
    })
    .catch(function(error) {
      console.log(error);
      return [];
    })
    .finally(function() {});
};

export default searchDenominations;
